<onsip-header-main>
  <onsip-header-page-title>
    {{ "ONSIP_I18N.SAYSO_DASHBOARD_LAST_60_MINUTES" | translate }}
  </onsip-header-page-title>
  <onsip-header-action-bar>
    <mat-form-field appearance="outline">
      <input
        matInput
        [formControl]="search"
        [placeholder]="'ONSIP_I18N.SEARCH' | translate"
        autocomplete="off"
      />
      <mat-icon color="primary" matSuffix>search</mat-icon>
    </mat-form-field>
  </onsip-header-action-bar>
</onsip-header-main>
<section>
  <!-- DESKTOP VIEW -->
  <onsip-table-two
    multiTemplateDataRows
    class="manager-table"
    [dataSource]="dataSource"
    [hoverable]="true"
    [gridTemplateColumns]="'2.75fr repeat(6, 1fr)'"
  >
    <!-- NAME COLUMN-->
    <ng-container matColumnDef="topic-name">
      <mat-header-cell *matHeaderCellDef>{{ "ONSIP_I18N.TOPIC_NAME" | translate }}</mat-header-cell>
      <mat-cell
        class="topic-name-cell"
        *matCellDef="let topic"
        (click)="
          expandedElements.includes(topic['topic-name'])
            ? expandedElements.splice(expandedElements.indexOf(topic['topic-name'], 1))
            : expandedElements.push(topic['topic-name'])
        "
      >
        {{ topic["topic-name"] }}
      </mat-cell>
    </ng-container>
    <!-- POTENTIAL COLUMN -->
    <ng-container matColumnDef="potential">
      <mat-header-cell *matHeaderCellDef>{{ "ONSIP_I18N.POTENTIAL" | translate }}</mat-header-cell>
      <mat-cell class="table-cell" *matCellDef="let topic">{{ topic.potential }}</mat-cell>
    </ng-container>
    <!-- ON CALL COLUMN -->
    <ng-container matColumnDef="on-call">
      <mat-header-cell *matHeaderCellDef>{{ "ONSIP_I18N.ON_CALL" | translate }}</mat-header-cell>
      <mat-cell class="table-cell" *matCellDef="let topic">{{ topic["on-call"] }}</mat-cell>
    </ng-container>
    <!-- TOTAL COLUMN -->
    <ng-container matColumnDef="total">
      <mat-header-cell *matHeaderCellDef>{{ "ONSIP_I18N.TOTAL" | translate }}</mat-header-cell>
      <mat-cell class="table-cell" *matCellDef="let topic">{{ topic.total }}</mat-cell>
    </ng-container>
    <!-- ANSWERED COLUMN -->
    <ng-container matColumnDef="answered">
      <mat-header-cell *matHeaderCellDef>{{ "ONSIP_I18N.ANSWERED" | translate }}</mat-header-cell>
      <mat-cell class="table-cell" *matCellDef="let topic">{{ topic.answered }}</mat-cell>
    </ng-container>
    <!-- CANCELLED COLUMN -->
    <ng-container matColumnDef="cancelled">
      <mat-header-cell *matHeaderCellDef>{{ "ONSIP_I18N.CANCELLED" | translate }}</mat-header-cell>
      <mat-cell class="table-cell" *matCellDef="let topic">{{ topic.cancelled }}</mat-cell>
    </ng-container>
    <!-- REJECTED COLUMN -->
    <ng-container matColumnDef="rejected">
      <mat-header-cell *matHeaderCellDef>{{ "ONSIP_I18N.REJECTED" | translate }}</mat-header-cell>
      <mat-cell class="table-cell" *matCellDef="let topic">{{ topic.rejected }}</mat-cell>
    </ng-container>
    <!-- EXPANDED -->
    <ng-container matColumnDef="expanded">
      <onsip-table-shelf-cell
        *matCellDef="let element"
        [attr.colspan]="displayedColumns.length"
        [expanded]="expandedElements.includes(element['topic-name'])"
        [override]="true"
      >
        @if (expandedElements.includes(element['topic-name'])) {
        <div class="caller-agent-table">
          @if (!element['agent-info'] || element['agent-info'].length === 0) {
          <div class="empty-state">
            <span class="mat-body-1">{{
              "ONSIP_I18N.THERE_ARE_NO_AGENTS_AVAILABLE" | translate
            }}</span>
          </div>
          }
          <mat-list>
            @for (agent of element['agent-info']; track agent.id) {
            <mat-list-item>
              <span class="agent-name-block">
                <onsip-avatar [avatarUrl]="agent.avatar" [name]="agent.name"></onsip-avatar>
                <div class="presence-icons">
                  @if (agent.callStatus === 'available') {
                  <mat-icon class="agent-presence-available">check</mat-icon>
                  } @if (agent.callStatus === 'busy') {
                  <mat-icon class="agent-presence-oncall">call</mat-icon>
                  } @if (agent.callStatus === 'unavailable') {
                  <mat-icon class="agent-presence-away" svgIcon="onsip_presence_away"></mat-icon>
                  }
                </div>
                <div class="agent-name-time">
                  <div class="agent-name-display">{{ agent.name }} &nbsp;</div>
                  @if (agent.callStatus === 'busy') {
                  <div class="agent-call-time">
                    @if (agent.callStatus === 'busy' && agent.callStart) {
                    <onsip-timer [referencePoint]="agent.callStart"></onsip-timer>
                    }
                  </div>
                  }
                </div>
              </span>
            </mat-list-item>
            }
          </mat-list>
        </div>
        }
      </onsip-table-shelf-cell>
    </ng-container>
    <ng-container matColumnDef="mobile">
      <cdk-cell *cdkCellDef="let snapshot">
        <div class="sayso-status-item">
          <span
            class="sayso-status-mobile-name mat-body-1"
            id="onsip--sayso-realtime--sayso-snapshot-{{ snapshot['topic-name'] }}"
            (click)="
              expandedElements.includes(snapshot['topic-name'])
                ? expandedElements.splice(expandedElements.indexOf(snapshot['topic-name']), 1)
                : expandedElements.push(snapshot['topic-name'])
            "
          >
            <span class="sayso-status-mobile-sayso-name">{{ snapshot["topic-name"] }}</span>
            @if (expandedElements.includes(snapshot['topic-name'])) {
            <button mat-icon-button>
              <mat-icon>arrow_drop_up</mat-icon>
            </button>
            } @if (!expandedElements.includes(snapshot['topic-name'])) {
            <button mat-icon-button>
              <mat-icon>arrow_drop_down</mat-icon>
            </button>
            }
          </span>
          @if (expandedElements.includes(snapshot['topic-name'])) {
          <div class="caller-agent-table">
            <!-- Expanded Detail Column -->
            @if (!snapshot['agent-info'] || snapshot['agent-info'].length === 0) {
            <div class="empty-state">
              <span class="mat-body-1">{{
                "ONSIP_I18N.THERE_ARE_NO_AGENTS_AVAILABLE" | translate
              }}</span>
            </div>
            }
            <table
              mat-table
              class="agents-details-table"
              multiTemplateDataRows
              [dataSource]="snapshot['agent-info']"
              [trackBy]="trackByUserId"
            >
              <ng-container [matColumnDef]="snapshot['topic-name']">
                <td mat-cell *matCellDef="let agent" class="wide-column">
                  <span class="agent-name-block">
                    <onsip-avatar [avatarUrl]="agent.avatar" [name]="agent.name"></onsip-avatar>
                    <div class="presence-icons">
                      @if (agent.callStatus === 'available') {
                      <mat-icon class="agent-presence-available">check</mat-icon>
                      } @if (agent.callStatus === 'busy') {
                      <mat-icon class="agent-presence-oncall">call</mat-icon>
                      } @if (agent.callStatus === 'unavailable') {
                      <mat-icon
                        class="agent-presence-away"
                        svgIcon="onsip_presence_away"
                      ></mat-icon>
                      }
                    </div>
                    <div class="agent-name-time">
                      <div class="agent-name-display">{{ agent.name }} &nbsp;</div>
                      @if (agent.callStatus === 'busy') {
                      <div class="agent-call-time">
                        @if (agent.callStatus === 'busy' && agent.callStart) {
                        <onsip-timer [referencePoint]="agent.callStart"></onsip-timer>
                        }
                      </div>
                      }
                    </div>
                  </span>
                </td>
              </ng-container>
              <tr
                mat-row
                *matRowDef="let agent; columns: [snapshot['topic-name']]"
                class="agent-row"
              ></tr>
            </table>
          </div>
          }
          <table
            mat-table
            multiTemplateDataRows
            [dataSource]="[
              {
                name: 'potential',
                data: snapshot['potential'],
                displayName: 'ONSIP_I18N.POTENTIAL' | translate
              },
              {
                name: 'on-call',
                data: snapshot['on-call'],
                displayName: 'ONSIP_I18N.ON_CALL' | translate
              },
              {
                name: 'total',
                data: snapshot['total'],
                displayName: 'ONSIP_I18N.TOTAL' | translate
              },
              {
                name: 'answered',
                data: snapshot['answered'],
                displayName: 'ONSIP_I18N.ANSWERED' | translate
              },
              {
                name: 'cancelled',
                data: snapshot['cancelled'],
                displayName: 'ONSIP_I18N.CANCELLED' | translate
              },
              {
                name: 'rejected',
                data: snapshot['rejected'],
                displayName: 'ONSIP_I18N.REJECTED' | translate
              }
            ]"
            class="sayso-status-table"
          >
            <ng-container matColumnDef="overview-name">
              <td mat-cell *matCellDef="let element" class="overview-name even-column">
                <p>{{ element.displayName }}</p>
              </td>
            </ng-container>
            <ng-container matColumnDef="overview-data">
              <td mat-cell *matCellDef="let element" class="mobile-columns">
                <p class="mobile-column-data">{{ element["data"] }}</p>
              </td>
            </ng-container>
            <tr
              mat-row
              *matRowDef="let element; columns: ['overview-name', 'overview-data']"
              class="sayso-status-row"
            ></tr>
          </table>
        </div>
      </cdk-cell>
    </ng-container>
    <mat-header-row
      *matHeaderRowDef="(isMobile | async) ? null : displayedColumns"
    ></mat-header-row>
    <mat-row
      *matRowDef="let row; columns: displayedColumns; when: showDesktopRow.bind(this)"
    ></mat-row>
    <onsip-table-shelf
      *matRowDef="let row; columns: ['expanded']; when: showDesktopRow.bind(this)"
    ></onsip-table-shelf>
    <onsip-row
      *matRowDef="let row; columns: ['mobile']; when: showMobileRow.bind(this)"
    ></onsip-row>
  </onsip-table-two>
  <!-- EMPTY STATE -->
  @if (!dataSource.data.length && search.value) {
  <div class="empty-search">
    <img [src]="'resources/img/queue-status-page-icons/BuildingQueueSearch.svg'" alt="Loading" />
    <img
      class="radio-wave-line"
      [src]="'resources/img/queue-status-page-icons/RadioWaveLines.svg'"
      alt="Loading Lines"
    />
    <h4>{{ "ONSIP_I18N.THERE_ARE_NO_MATCHING_RESULTS" | translate }}</h4>
  </div>
  } @if (!dataSource.data.length && !search.value) {
  <div class="empty-search">
    <h4>There are no topics set up. Please go to the sayso Settings page to add a topic.</h4>
  </div>
  }
</section>
